import React from 'react';

import { Dayjs } from 'dayjs';
import dayjs from '~/timeInit';

import { DatePicker, DatePickerProps } from '@mui/x-date-pickers-pro';

type Props = Omit<DatePickerProps<Dayjs>, 'value' | 'onChange'> & {
  value?: string;
  onChange: (value: string) => void;
  fullWidth?: boolean;
  defaultTimezone?: string;
  'data-testid'?: string;
};

export default function DateWidget({
  value,
  onChange,
  fullWidth,
  defaultTimezone = window.configs.DEFAULT_TIMEZONE,
  'data-testid': dataTestId,
  slotProps,
  ...props
}: Props) {
  const date = value ? (defaultTimezone ? dayjs(value).tz(defaultTimezone) : dayjs(value)) : null;
  const textFieldSlotProps = typeof slotProps?.textField === 'function' ? undefined : slotProps?.textField;

  return (
    <DatePicker
      slotProps={{
        ...slotProps,
        textField: {
          fullWidth,
          ...textFieldSlotProps,
          inputProps: {
            'data-testid': dataTestId,
            ...(textFieldSlotProps?.inputProps ?? {}),
          },
        },
      }}
      format="DD/MM/YYYY"
      {...props}
      value={date}
      onChange={(date, context) => {
        if (date && (!date.isValid() || context.validationError)) return;
        onChange(date ? date.format('YYYY-MM-DD') : '');
      }}
    />
  );
}
